if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute('data-media-id');
        this.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.toggle('active', element.getAttribute('data-media-id') === mediaId);
        });

        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        const container = this.querySelector('[role="document"]');

        // Align once when the lightbox opens. Repeating this as later photos load
        // resets scrollTop and snaps the customer back to the opened image.
        let positioned = false;
        let adjusting = false;

        const alignToActive = () => {
          if (positioned) return;

          const top =
            activeMedia.getBoundingClientRect().top - container.getBoundingClientRect().top + container.scrollTop;
          adjusting = true;
          container.scrollTop = top;

          if (activeMedia.width > container.clientWidth) {
            container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
          }

          adjusting = false;
        };

        const finishPositioning = () => {
          positioned = true;
          container.removeEventListener('scroll', onScroll);
        };

        const onScroll = () => {
          if (adjusting) return;
          finishPositioning();
          window.cancelAnimationFrame(positionFrame);
        };

        alignToActive();
        const positionFrame = window.requestAnimationFrame(() => {
          alignToActive();
          finishPositioning();
        });

        container.addEventListener('scroll', onScroll, { passive: true });

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
